export default class ManageWorkspaceController {
  constructor($scope, workspace, rename, deleteWorkspace, close) {
    this.$scope = $scope;
    this.workspace = workspace;
    this.rename = rename;
    this.deleteWorkspace = deleteWorkspace;
    this.close = close;
  }
}